import { useEffect, useRef, useState } from 'react';
const LEAVE_DEBOUNCE_MS = 80;
export const useDragAndDrop = ({ disabled, onDrop }) => {
    const [isDragging, setIsDragging] = useState(false);
    const leaveTimeoutRef = useRef(null);
    const clearLeaveTimeout = () => {
        const timerId = leaveTimeoutRef.current;
        leaveTimeoutRef.current = null;
        if (timerId !== null)
            clearTimeout(timerId);
    };
    useEffect(() => {
        return () => clearLeaveTimeout();
    }, []);
    const startDrag = () => {
        if (disabled)
            return;
        clearLeaveTimeout();
        setIsDragging(true);
    };
    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        startDrag();
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        startDrag();
    };
    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        clearLeaveTimeout();
        leaveTimeoutRef.current = setTimeout(() => {
            leaveTimeoutRef.current = null;
            setIsDragging(false);
        }, LEAVE_DEBOUNCE_MS);
    };
    const handleDrop = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        clearLeaveTimeout();
        setIsDragging(false);
        if (disabled)
            return;
        const file = e.dataTransfer.files?.[0];
        if (!file)
            return;
        await onDrop(file);
    };
    return {
        isDragging,
        handleDragEnter,
        handleDragOver,
        handleDragLeave,
        handleDrop,
    };
};
